import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import { Box, Link as MuiLink } from '@mui/material';

export const HeaderContact = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: { xs: 4, sm: 6 },
                alignItems: 'center',
                color: 'text.secondary',
                fontSize: '0.95rem',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailOutlinedIcon fontSize="small" />
                <MuiLink
                    href="mailto:info@kanzlei-imrecht.de"
                    underline="hover"
                    color="inherit"
                >
                    info@kanzlei-imrecht.de
                </MuiLink>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneOutlinedIcon fontSize="small" />
                <MuiLink
                    href="tel:+4915202016852"
                    underline="hover"
                    color="inherit"
                >
                    +49 152 02016852
                </MuiLink>
            </Box>
        </Box>
    )
}